import { StyleSheet, Text, View } from "@react-pdf/renderer"
import PropTypes from "prop-types"
import React from "react"

const styles = StyleSheet.create({
  section: {},

  sectionHeader: {
    padding: 6,
    fontSize: 14,
    marginBottom: 8,
    marginTop: 8,
    textAlign: 'left',
    color: '#FEDB00',
    backgroundColor: '#424242',
  },

  sectionHeaderSecondary: {
    backgroundColor: '#E0E0E0',
    color: 'black',
  },

  sectionContainer: {
    padding: 8,
  },
})

const Section = ({ children }) => (
  <View style={styles.section}>
    {children}
  </View>
)

Section.propTypes = {
  children: PropTypes.node.isRequired,
}


export const SectionHeader = ({ text, variant }) => (
  <Text
    style={[styles.sectionHeader, variant === 'secondary' ? styles.sectionHeaderSecondary : {}]}
  >
    {text}
  </Text>
)

SectionHeader.propTypes = {
  text: PropTypes.string.isRequired, variant: PropTypes.oneOf(['primary', 'secondary']),
}

SectionHeader.defaultProps = {
  variant: 'primary',
}

export const SectionContent = ({ children }) => (
  <View style={styles.sectionContainer}>
    {children}
  </View>
)

SectionContent.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Section
